import type { Theme } from '@mui/material';

import { Z_INDEX_LAYERS } from 'src/constants/settings';

export const styles = {
  followUpInspirationsButton:
    (pulseAnimation: boolean, clicked: boolean) => (theme: Theme) => ({
      position: 'fixed',
      right: 0,
      top: 190,
      zIndex: Z_INDEX_LAYERS.FRONT.BASE,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 20,
      borderBottomLeftRadius: 20,
      height: '2.75rem',
      transition: 'width 0.3s ease, transform 0.3s ease',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      '@keyframes fui-pulse-animation': {
        '0%': {
          transform: 'scale(1)',
        },
        '50%': {
          transform: 'scale(1.3)',
        },
        '100%': {
          transform: 'scale(1)',
        },
      },
      animation: pulseAnimation
        ? 'fui-pulse-animation 1s ease-in-out infinite'
        : 'none',
      width: clicked ? '100%' : 0,
      maxWidth: '18.5rem',
      [theme.breakpoints.up('lg')]: {
        top: 290,
        maxWidth: '23.75rem',
      },

      ...(clicked
        ? {
            '.fui-banner-content': {
              display: 'flex',
            },
          }
        : {}),

      '&:hover': {
        width: '23.75rem',

        '.fui-banner-content': {
          display: 'flex',
        },
      },
    }),

  buttonTextContainer: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },

  buttonText: {
    transition: 'opacity 0.3s ease',
    whiteSpace: 'nowrap',
    marginLeft: '10px',
  },

  followUpIcon: {
    width: '2rem',
    height: '2rem',
  },
};
